import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeatureCard2Block as Block } from "./FeatureCard2";
import { defaultData } from "./FeatureCard2DefaultData";
import imagePreview from "./feature-card-2-preview.png";

export const FeatureCard2: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Feature Card 2",
    nameI18n: "builder_ui.block_type.feature_card_2",
    version: 1,
    isHidden: true,
    props: {
      icon: {
        name: "Icon",
        nameI18n: "builder_ui.prop_type.icon",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      titleContent: {
        name: "Title",
        nameI18n: "builder_ui.prop_type.title",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      image: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      description: {
        name: "Description",
        nameI18n: "builder_ui.prop_type.description",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
